<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Character Tree Node"
  model-name="characterTree"
  param="characterTreeNodeId"
  page-prefix="/blade/character-tree"
  :create="createCharacterTree"
  :fetch="getCharacterTreeNode"
  :update="updateCharacterTree"
  :remove="deleteCharacterTree"
  :stub="characterTreeStub"
  :validator="validator"
  :utils="utils"
  :hide-buttons="!canManageGames">
<template slot-scope="{ model: gameSet, utils: { unused }, validator }">
  <div>
    <text-input label v-model.trim="gameSet.name" :validator="validator.name" required autofocus>Name</text-input>
    <text-input label v-model.trim="gameSet.title" :validator="validator.title" required>Title</text-input>
    <checkbox-input v-model="gameSet.isVisibleByDefault">Visible by default</checkbox-input>

    <!-- :hide-button="gameSet.games.length >= characters.filter(c => c.avatar).length" -->
    <array-input
      :items="gameSet.games"
      :disabled="validator.games.$invalid && gameSet.games.length > 0"
      required
    >
      <h5 slot="title">
        Gamulations
      </h5>
      <div slot="item" slot-scope="{ item: game, index: i }">
        <div class="form-row">
          <select-input
            v-model="game._id"
            :validator="validator.games.$each[i]._id"
            :options="unused(gameList).by('_id').in(gameSet.games).by('_id').at(i)"
            use="_id"
            display="name"
            required
            autofocus
            :to="(id) => { return `/blade/games/${id}/edit`; }"
            :remove="()=>{ gameSet.games.splice(i, 1); }"
          >
            Game
          </select-input>
          <checkbox-input style="margin-left: 10px;" v-model="game.disabled">Disabled (visible but not selectable)</checkbox-input>
        </div>
        <!-- <number-input style="margin-left: 50px;" v-model="game.cost">Cost</number-input> -->
        <div style="margin-bottom: 15px; height: 1px; width: 100%; background-color: rgba(0,0,0,0.5);"/>
      </div>
      <span slot="button">Add Gamulation</span>
    </array-input>
  </div>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';

import { unused } from '../../../utils/utils';

import EditPage from '../../ui/pages/EditPage';
import NarrativeInput from '../../ui/inputs/NarrativeInput';

import ArrayInput from '../../ui/inputs/ArrayInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';
import NumberInput from '../../ui/inputs/NumberInput';
import AssetSelectInput from '../../ui/inputs/AssetSelectInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';
import CollapsibleSection from '../../ui/inputs/CollapsibleSection';

export default {
  components: {
    EditPage,
    NarrativeInput,
    ArrayInput,
    CheckboxInput,
    NumberInput,
    AssetSelectInput,
    SelectInput,
    TextInput,
    CollapsibleSection
  },
  data() {
    return {
      utils: {
        unused
      },
      gameList: [],
      gameSetStub: {
        _id: '',
        name: '',
        title: '',
        isVisibleByDefault: false,
        games: []
      },
      validator: {
        name: { required },
        title: { required },
        games: {
          $each: {
            _id: { required }
          }
        },
      }
    };
  },
  computed: {
    ...mapGetters([
      'canManageGameSets'
    ]),
    creating() {
      return !(this.$route.params.gameSetId);
    }
  },
  methods: {
    ...mapActions([
      'getGameSet',
      'getGames',
      'createGameSet',
      'updateGameSet',
      'deleteGameSet',
    ]),
    computeCreationDateString(date) {
      if (!date) {
        return '';
      }
      return new Date(date).toLocaleString();
    },
  },
  async mounted() {
    this.gameList = await this.getGames();
    console.log(this.gameList);
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/CharacterTreeEdit.vue